import React, { FC, ReactNode } from "react";
import { usePushNotificationContext } from "./usePushNotificationContext";
import { PushNotificationContext } from "./PushNotificationContext";

export const PushNotificationProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const value = usePushNotificationContext();

  return (
    <PushNotificationContext.Provider value={value}>
      {children}
    </PushNotificationContext.Provider>
  );
};
